import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import routes from '.';
import LoadingScreen from '../components/LoadingScreen';
import ScrollToTop from '../components/ScrollToTop/ScrollToTop';
import { ITranslations } from '../i18n/config';
import { useAuthentication } from '../state/Authentication';
import flattenRoutes from '../util/flattenRoutes';

export type RouteObject<P = string> = {
  path?: P;
  exact: boolean;
  breadcrumb?: ITranslations;
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  routes?: RouteObject<P>[];
  unprotected?: boolean;
};

const ProtectedRoute: React.FC<RouteObject> = (props) => {
  const {
    state: { isAuthenticated, isAuthLoaded, isLoaded },
  } = useAuthentication();

  React.useEffect(() => {
    if (!isAuthLoaded || isAuthenticated) return;

    window.location.href = `/auth/login?fromUrl=${window.location.href}&auth_methods=iam-aprofiel-phone,fas-citizen-bmid,fas-citizen-eid,fas-citizen-totp,fas-citizen-otp,iam-aprofiel-userpass`;
  }, [isAuthenticated, isAuthLoaded]);

  if (!isLoaded) {
    return <LoadingScreen />;
  }

  return <Route {...props} />;
};

const Router = (): JSX.Element => {
  const flatten = React.useCallback(flattenRoutes, [routes]);

  return (
    <ScrollToTop>
      <Switch>
        {flatten(routes).map(({ path, unprotected, ...props }) => {
          const key = uuidv4();

          if (unprotected) {
            return <Route path={path} key={key} {...props} />;
          }

          return <ProtectedRoute path={path} key={key} {...props} />;
        })}
      </Switch>
    </ScrollToTop>
  );
};

export default Router;
